import * as React from 'react';
import ConfirmationModal from 'components/Common/confirmationModal';
import './inviteUserModal.scss';

interface IInviteUserModalProps {
    user: Nullable<IUserInvite>;
    onCloseClick(): void;
    onConfirmClick(): void;
}

export class InviteUserModal extends React.Component<IInviteUserModalProps> {

    constructor(props: IInviteUserModalProps) {
        super(props);
        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.handleConfirmClick = this.handleConfirmClick.bind(this);
    }

    render(): React.ReactNode {
        return (
            <ConfirmationModal
                className="invite-user-modal"
                message={this.renderModalBody()}
                onCancel={this.handleCloseClick}
                onClose={this.handleCloseClick}
                onConfirm={this.handleConfirmClick}
                title="Add User"
                confirmMessage="Yes, Add User"
            />
        );
    }

    renderModalBody(): React.ReactNode {
        const { user } = this.props;
        if (!user) {
            return null;
        }
        const userName = `${user.firstName} ${user.lastName}`;
        const headerText = `We'll send ${userName} an email invitation to join Team. Once a user is added they are able to:`;
        return (
            <div className="invite-user-modal__body">
                <div className="invite-user-modal__body-top-content">
                    {headerText}
                </div>
                <div className="invite-user-modal__body-bottom-content">
                    <div className="invite-user-modal__text-container">
                        <i className="icon-check invite-user-modal__check" />
                        <div className="invite-user-modal__explanation-text">
                            Login and review compensation details for their team
                        </div>
                    </div>
                    <div className="invite-user-modal__text-container">
                        <i className="icon-check invite-user-modal__check" />
                        <div className="invite-user-modal__explanation-text">
                            Make pay decisions for their team during an open cycle
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    handleCloseClick(): void {
        this.props.onCloseClick();
    }

    handleConfirmClick(): void {
        this.props.onConfirmClick();
    }
}

export default { InviteUserModal };